import { createFileRoute } from '@tanstack/react-router';

import { TrainingView } from 'views/TrainingView';

export const Route = createFileRoute('/_auth/_buttonView/_layout/training/')({
  component: TrainingView,
  staticData: {
    title: 'Training',
  },
});
